// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import Vant from "vant";
import "vant/lib/index.css";
import { Lazyload } from "vant";
import "@/styles/index.scss"; // global css
import ElementUI from 'element-ui'

import amapFile from'../static/sdk/amap-wx';

//将其绑定到vue原型上  //使用 this.$myAmapFun访问
// let myAmapFun = new amapFile.AMapWX({ key: 'ec0f8fe9bdd332f3811aecab234d3912' });
// Vue.prototype.$myAmapFun = myAmapFun

// 上传组件
import {
  Upload,
  FormItem,
  Form,
  Input,
  Button,
  Select,
  Option,
  OptionGroup,
  Tree
} from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import "../mock"; // simulation data

Vue.use(Vant);
Vue.use(Lazyload, {
  attempt: 1
});
Vue.use(Upload);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Button);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Tree);
Vue.use(ElementUI)

// collapse 展开折叠
import CollapseTransition from "element-ui/lib/transitions/collapse-transition";

Vue.component(CollapseTransition.name, CollapseTransition);

import "@/icons"; // svg icon

// 表单验证
// import VeeValidate from 'vee-validate';
// import { Validator } from "@/validate/index.js";//一些小问题的修改
// import zh_CN from 'vee-validate/dist/locale/zh_CN';
// Validator.localize('zh_CN', zh_CN)
// const config = {
//   errorBagName: 'errorBags', // change if property conflicts.
//   fieldsBagName: 'fieldBags',
// };
// Vue.use(VeeValidate, config)
import "@/validate/index.js";
// 与element有冲突
// 全局组件
import components from "@/base/index.js";
components.forEach(item => Vue.component(item.name, item));
// 过滤器
import Filters from "@/filter";
// 全局过滤器
for (let prop in Filters) {
  Vue.filter(prop, Filters[prop]);
}
Vue.config.productionTip = false;

window.eventBus = new Vue(); //注册全局事件对像

// 全局函数(删除（含弹窗）)
import "@/globalFuc/index.js";
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js